export * from './FolderIcon';
export * from './FolderIcon16Light';
export * from './FolderIcon16Regular';
export * from './FolderIcon16Solid';
export * from './FolderIcon20Light';
export * from './FolderIcon20Regular';
export * from './FolderIcon20Solid';
export * from './FolderIcon24Regular';
export * from './FolderIcon24Solid';
export * from './FolderIcon32Regular';
export * from './FolderIcon64Regular';
